<ion-content class="modal-options ion-padding">
  <ng-container>
    <div class="modal-form-container">
      <div class="content-top">
        <h3 class="title">{{ "share-ticket-modal.title" | translate }}</h3>
        <!-- Message to share -->
        <div class="message-to-share">
          <div class="message-box">
            <a [href]="shareUrl" target="_blank" class="ticket-link">
              {{ shareUrl }}
            </a>
          </div>
        </div>
      </div>
      @if (!isNative) {
      <div class="share-buttons">
        <div class="share-button" (click)="shareWhatsApp()">
          <img src="assets/icons/whatsapp-icon.svg" alt="WhatsApp" />
          <span>{{ "share-buttons.whatsapp" | translate }}</span>
        </div>
        <div class="share-button" (click)="shareInstagram()">
          <img src="assets/icons/instagram-icon.svg" alt="Instagram" />
          <span>{{ "share-buttons.instagram" | translate }}</span>
        </div>
      </div>
      }

      <div class="copy-divider"></div>
      @if (isNative) {
      <div class="custom-copy-button" (click)="shareMessageNative()">
        <div class="icon-circle">
          <img src="assets/icons/share-icon.svg" class="option-icon" />
        </div>
        <span class="copy-text">{{
          "share-microsite.share-link" | translate
        }}</span>
      </div>
      } @if (!isNative) {
      <div class="custom-copy-button" (click)="copyShareMessageToClipboard()">
        <div class="icon-circle">
          <ion-icon name="copy-outline" />
        </div>
        <span class="copy-text">{{
          "share-microsite.copy-link" | translate
        }}</span>
      </div>
      }
    </div>
  </ng-container>
</ion-content>
